//#region Imports

/**
To use React and state related functionality
*/
import React from 'react';
/**
Allows component  to connect the Redux store.
*/
import {connect} from 'react-redux';
/**
parse is used to parse the date. 
isSameDay is used to check if 2 dates are same day or not
addMinutes is used to add minutes in date object.
format is used to fromat date.
*/
import { parse, isSameDay, format, addMinutes} from 'date-fns';
/**
To show icons.
*/
import {IconChevron, IconPedestrian} from '../Icons';
/**
Show trip leg.
*/
import TripLeg from './TripLeg';
/**
To use Transit Badge trip leg details. It is used in getTripLegIcon method.
*/
import TransitBadge from './TransitBadge';
/**
To use Transit Warnings it trip leg details
*/
import TripWarnings from './TripWarnings';
/**
Convert trip duration(number) in words.
*/
import { durationInWords } from '../../utils/directionsUtilities';
/**
To use PRINT_PAGE cosntant from actions.
*/
import {PRINT_PAGE} from '../../actions'; //Feature_issue-9 Changes -- Vishal Chauhan
//#endregion

const Itinerary = props => {
    //trip : trip detail
    //label: used to show trip number
    //isOpen : current trip is open or not
    //handleClick : handles on click event on trip box
    //dispatch : used to dispatch print page event
    const {trip,label,isOpen,handleClick,dispatch} = props; //Feature_issue-9 Changes -- Vishal Chauhan
    //set css class as per trip section visibility
    const accordionClass = isOpen ? 'otp-accordion-section open' : 'otp-accordion-section';
    //set area lable as per trip section visibility
    const ariaLabel = isOpen ? 'Close trip detail panel' : 'Open trip detail panel';
    //trip requested date
    const requestStart = parse(props.requestDate);
    //it is used to get time zone difference
    const agencyOffset = (trip.legs[0].agencyTimeZoneOffset) / (60 * 1000);
    //stores current data and used to get timezone difference
    const today = new Date();
    //used to get start and end datetime
    const timezoneDiff = agencyOffset + today.getTimezoneOffset();
    //trip start time
    const tripStart = addMinutes(parse(trip.startTime), timezoneDiff);
    //trip end time
    const tripEnd = addMinutes(parse(trip.endTime), timezoneDiff);
    //Feature_issue-9 Changes -- Vishal Chauhan  Start
    //Saves values to detect controls is back from print page
    const setView=()=>{    
        //set value to identify if current control comes from Itinary page
        //It is used in Map>>Index.js page
        localStorage.setItem("IsFromPrintPage","True")
        dispatch({type:PRINT_PAGE, payload:{}});
    }
    //Feature_issue-9 Changes -- Vishal Chauhan  End

    return(
        <div className={accordionClass}>
            <button
                className="otp-accordion-header"
                id={`otp-accordion-header-${label}`}
                onClick={handleClick}
                aria-controls={`otp-accordion-panel-${label}`}
                aria-expanded={isOpen}
                aria-label={ariaLabel}
            >
                <div className="otp-trip-label">
                    {label}
                </div>
                <div className="otp-trip-summary">
                    <div className="otp-trip-details">
                        <div>
                            <span className="otp-trip-time">
                                {format(tripStart, 'h:mm a')} - {format(tripEnd, 'h:mm a')}
                            </span>
                            {/* Shows trip warnings */}
                            <TripWarnings trip={trip} />
                        </div>
                        <div className="otp-trip-icons">
                            {/* loop over trip legs */}
                            {trip.legs.map(leg => {
                                if (leg.interlineWithPreviousLeg) {
                                    return;
                                }
                                const key = leg.startTime.toString() + leg.duration.toString();
                                return (
                                    <div
                                        className="otp-icon-wrapper"
                                        key={key}
                                    >
                                        {getTripLegIcon(leg)}
                                    </div>);
                            })}
                        </div>
                    </div>
                    <div className="otp-trip-duration">
                        {/* convert duration in words  */}
                        {durationInWords(trip.duration)}
                    </div>
                    <div className="otp-accordion-icon">
                        <IconChevron />
                    </div>
                </div>
            </button><div
                className="otp-accordion-panel"
                id={`otp-accordion-panel-${label}`}
            >
                {/* if start and end time is different then show trip date */}
                {!isSameDay(tripStart, requestStart) &&
                        <div className="otp-directions-caption">Trip Date: {format(tripStart, 'dddd, MMMM Do')}</div>}
                {trip.legs.map((leg, idx) => {
                    const key = leg.duration.toString() + leg.startTime.toString();
                    return (<TripLeg details={leg} key={key} idx={idx} />);
                })}
                {/* Feature_issue-9 Changes -- Vishal Chauhan  Start */}
                <div className="otp-button-primary otp-edit-button align-right">
                    {/* Hide current Trip and display print  */}
                    <button onClick={() => setView()}>Print Trip</button>
                </div>  
                {/* Feature_issue-9 Changes -- Vishal Chauhan  End */}
            </div>
        </div>
    );
};
//Returns trip icon
const getTripLegIcon = leg => {
    //if mode is walk then return IconPedestrian else return transit badge
    if (leg.mode === 'WALK') {
        return <div className="otp-trip-icon"><IconPedestrian /></div>;
    } else {
        return <TransitBadge leg={leg} />;
    }
};

//Controls get updated when change any requested date is changed
const mapStateToProps = state => {
    return {
        //stores requested date
        requestDate: state.form.fields.date.value
    };
    
};

export default connect(mapStateToProps)(Itinerary);